export default __webpack_public_path__ + "static/media/Imgen_firma.97b29434.png";